import * as yup from 'yup';

const validationSignIn = yup.object().shape({
  email: yup.string().required('Required').email('Invalid email format'),
  password: yup
    .string()
    .required('Required')
    .min(8, 'minimum 8 chars')
    .matches(/[a-zA-Z]/, 'Password can only contain Latin letters.'),
});

export default validationSignIn;
